<template>
  <div class="modal fade" id="import-airbnb-rentals-to-get-link" aria-hidden="false" aria-labelledby="exampleGrid" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-simple modal-center" style="min-width:730px">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container">
            <div class="row header">
              <div class="col-8">
                <h4 class="modal-title text-left">Lien de connexion Airbnb</h4>
              </div>
              <div class="col-4">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeModal('#import-airbnb-rentals-to-get-link')">
                  <span aria-hidden="true" class="close-btn">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="form-group form-material">
            <p class="connection-link-description">
              Voici votre lien de connexion Airbnb :
            </p>
            <div class="connection-link-container">
              <div class="link-display">
                <span class="link-text">{{ link }}</span>
                <button 
                  type="button" 
                  class="btn btn-sm btn-outline-primary copy-link-btn waves-effect waves-classic" 
                  @click.prevent="copyLinkToClipboard"
                  :disabled="!link"
                >
                  <i class="fa fa-copy"></i> Copier
                </button>
              </div>
            </div>
          </div>
        </div>
        <v-loading 
          v-bind:isLoading="loading" 
          v-bind:height="50" 
          v-bind:width="50" 
          v-bind:viewbox="'0 0 50 50'"
          v-bind:cx="25" 
          v-bind:cy="25" 
          v-bind:r="22" 
          v-bind:isHeightAuto="true">
        </v-loading>
        <div class="modal-footer text-center">
          <button 
            type="button" 
            class="btn waves-effect waves-classic btn-cancel"
            @click.prevent="closeModal('#import-airbnb-rentals-to-get-link')"
            data-dismiss="modal"
            :disabled="loading"
          >
            {{ $t('button.close') || 'Fermer' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import mixin from '../../../../mixins/mixin';
    import airbnbService from '../../../../services/airbnb';

    export default {
      name: 'ImportNewAirbnbRentalsToGetLink',
      data() {
        return {
          link: '',
          loading: false
        };
      },
      components: {
        VLoading: require('components/loading/loading.vue'),
      },
      mixins: [mixin],
      methods: {
        async loadLink(account) {
          this.loading = true;
          try {
            this.link = await airbnbService.getConnectionLink(account);
          } catch (error) {
            console.error('Error loading Airbnb link:', error);
            this.$toast.error(this.$t('error.generic') || 'Une erreur est survenue');
          } finally {
            this.loading = false;
          }
        },
        async openNewImportModalToGetLink(account) {
          this.openModal('#import-airbnb-rentals-to-get-link');
          await this.loadLink(account);
        },
        copyLinkToClipboard() {
          if (!this.link) return;
          
          // Modern approach with navigator.clipboard if available
          if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(this.link).then(() => {
              this.$toast.success(this.$t('messages.link_copied') || 'Lien copié dans le presse-papiers');
            }).catch(() => {
              this.fallbackCopyToClipboard();
            });
          } else {
            this.fallbackCopyToClipboard();
          }
        },
        fallbackCopyToClipboard() {
          const el = document.createElement('textarea');
          el.value = this.link;
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
          this.$toast.success(this.$t('messages.link_copied') || 'Lien copié dans le presse-papiers');
        }
      },
      computed: {
        account() {
          return this.$store.state.account;
        }
       }
    };
</script>

<style scoped>
.connection-link-description {
  margin-bottom: 15px;
  color: #666;
  font-size: 14px;
}

.connection-link-container {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 10px;
}

.link-display {
  display: flex;
  align-items: center;
  gap: 10px;
}

.link-text {
  flex: 1;
  word-break: break-all;
  font-family: monospace;
  font-size: 13px;
  color: #495057;
  background-color: #fff;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.copy-link-btn {
  flex-shrink: 0;
  min-width: auto;
  white-space: nowrap;
}

.copy-link-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.modal-footer {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// ImportNewAirbnbRentalsToGetLink.vue?37c9fa5e